import axios from "../axios";

const updateFeeChildPartner = async function (accessToken,data) {
    try {
        const response = await axios.post('child-partner/updateFeeChildPartner', data, {
            headers: {
                'Authorization': accessToken
            },
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updateFeeChildPartner;
